import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: () => import('../views/index')
  },
  {
    path: '/index',
    name: '首页',
    component: () => import('../views/index')
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/login')
  },
  {
    path: '/register',
    name: '注册',
    component: () => import('../views/register/index')
  },
  {
    path: '/search',
    name: '搜索',
    component: () => import('../views/search/index')
  },
  {
    path: '/consultation',
    name: '咨询公告',
    component: () => import('../views/consultation')
  },
  {
    path: '/catalog',
    name: '合格评定目录',
    component: () => import('../views/catalog')
  },
  {
    path: '/server',
    name: '机构服务平台',
    component: () => import('../views/server')
  },
  {
    path: '/about',
    name: '关于我们',
    component: () => import('../views/about')
  },
  {
    path: '/authenticationQuery',
    name: '认证查询',
    component: () => import('../views/authenticationQuery')
  },
  {
    path: '/authenticationDetail',
    name: '认证查询',
    component: () => import('../views/authenticationQuery/detail')
  },
  {
    path: '/authenticationRuleQuery',
    name: '认证规则查询',
    component: () => import('../views/authenticationRuleQuery')
  },
  {
    path: '/authenticationRuleDetail',
    name: '认证规则详情',
    component: () => import('../views/authenticationRuleQuery/detail')
  },
  {
    path: '/users',
    name: '用户中心',
    component: () => import('../views/users')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
